import { useSelector as useReduxSelector, useDispatch as useReduxDispatch, TypedUseSelectorHook } from 'react-redux';
import { admin } from 'store';

export const useSelector: TypedUseSelectorHook<admin.RootState> = useReduxSelector;
export const useDispatch = () => useReduxDispatch<admin.AppDispatch>();
